import { AfterViewInit, Component, inject } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import FieldsConstants from 'src/app/common/fields.constants';
import { DateValidationService } from 'src/app/forms/fields/components/date-validation.service';
import { DependentDatePickerData } from 'src/app/interfaces/form-and-field.interface';
import { FormFieldSate } from '../form-field.state';
import { CustomDateFormatter } from './custom-date.formatter';

@Component({
  selector: 'app-date-picker-form-field',
  templateUrl: './date-picker-form-field.component.html',
  styleUrls: ['./date-picker-form-field.component.scss'],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateFormatter }],
})
export class DatePickerFormFieldComponent extends FormFieldSate implements AfterViewInit {
  public date: NgbDateStruct;

  public minDate: NgbDateStruct;
  public maxDate: NgbDateStruct;

  private ngbDateParserFormatter = inject(NgbDateParserFormatter);
  private validator = inject(DateValidationService);

  public ngAfterViewInit(): void {
    this.initRangeDates();
    this.initInitialData();
  }

  public onDateChanged(): void {
    let controlValue = '';
    if (this.date) {
      const month: number = this.date.month - 1;
      controlValue = this.date.year
        ? new Date(this.date.year, month, this.date.day).toLocaleDateString('en-US')
        : String(this.date);
    }

    this.control.setValue(controlValue);
  }

  public handleInputChange($event: { target: HTMLInputElement }): void {
    this.control.setValue($event.target.value);
  }

  public setAsTouched(): void {
    this.control.markAsTouched();
  }

  protected override onDefinedControlValue(value: DependentDatePickerData | string): void {
    if (typeof value !== 'string') {
      this.control.setValue(value.origin, { onlySelf: true });
      this.minDate = value.minDate;
      this.checkYear(value.maxDate) ? (this.maxDate = value.maxDate) : null;
    }
  }

  private initInitialData(): void {
    this.date = this.ngbDateParserFormatter.parse(this.control.value as string);
    this.onDateChanged();
  }

  private initRangeDates(): void {
    this.minDate = this.validator.getMinDate(this.fieldAttribute);
    this.maxDate = this.validator.getMaxDate(this.fieldAttribute);
  }

  private checkYear(date: NgbDateStruct): boolean {
    return date ? date.year >= FieldsConstants.MIN_YEAR_ALLOW : false;
  }
}
